import { wxGetThirdType } from '@/utils/http/modules/agent/agent.request'
import { PAY_THIRD_TYPE } from '@/utils/enum/pay.enum'

let requestingPromise = null // 正在请求中
let isRequested = false // 标记是否已经请求过
let thirdPayType = PAY_THIRD_TYPE.LIANLIAN

/** 获取第三方支付类型 */
export const getThirdPayType = async zbid => {
  if (isRequested) {
    // 如果已经请求过，直接返回之前的结果
    return thirdPayType
  }
  if (!requestingPromise) {
    // 如果没有正在请求的 Promise，创建一个新的请求
    const _promise = wxGetThirdType({
      tenantId: zbid,
    })
    requestingPromise = new Promise(resolve => {
      _promise.then(res => {
        if (res.isok && typeof res.data == 'number') {
          thirdPayType = res.data // 保存结果到变量中
          isRequested = true // 标记为已请求过
          resolve(thirdPayType) // 返回结果
        } else {
          resolve(PAY_THIRD_TYPE.LIANLIAN) // 返回默认值
        }
      })
    })
    const result = await requestingPromise // 等待请求完成
    requestingPromise = null // 重置请求状态
    return result // 返回结果
  } else {
    // 如果有正在请求的 Promise，等待它完成
    await requestingPromise // 等待请求完成
    return thirdPayType // 返回结果
  }
}
